import React from 'react';
import Typewriter from 'typewriter-effect';
import "../../css/Banner.css";
import "../../css/Classes.css";
import bannerImg from "../../images/banner.png";
const Banner = () => {
    return (
        <div className="banner">
            <div className="banner__container container" style={{height: "100vh"}}>
                <div className="banner__left">
                    <h3 data-aos="fade-up" data-aos-delay="100" className="banner__left__top__header">HEY<span className="main-color">!</span> I AM </h3>
                    <h1 data-aos="fade-right" data-aos-delay="150" className="banner__left__heading">ABU BAKKAR</h1>
                    <h1 data-aos="fade-right" data-aos-delay="200" className="banner__left__heading"> SIDDIK </h1>
                    <div data-aos="fade-up" data-aos-delay="300" className="banner__left__typewriter">
                        <span>I'm a</span>
                        <Typewriter
                            options={{
                                strings: ['Programmer', 'Designer', "Mern Stack Developer"],
                                autoStart: true,
                                loop: true,
                                deleteSpeed: 300,
                                wrapperClassName: "typewriter "
                            }
                            }
                        />
                    </div>
                </div>
                <div data-aos="zoom-in" data-aos-delay="200" className="banner__right">
                    <img className="banner__right__img img-fluid" src={bannerImg} alt="ab-siddik" />
                </div>
            </div>
        </div>
    )
}

export default Banner
